import '@sapudex/web-components/dist/Button.js';
import '@ui5/webcomponents-icons/dist/download.js';
import { udex } from '../../../scripts/dom-builder.js';
import getI18next from '../../../scripts/utils/translations/get-translations.js';

export async function getDownloadButton() {
  const i18next = await getI18next();
  const downloadLabel = i18next.t(
    'Finder.Variation.ECCN.Results.Download.Excel.Link.Text',
    'Download the table',
  );

  return udex(
    'button',
    {
      design: 'Tertiary',
      size: 'Large',
      icon: 'download',
      accessibleName: downloadLabel,
      disabled: true,
      tooltip: downloadLabel,
    },
    downloadLabel,
  );
}
